<div class="flex flex-col h-full">
	<div class="p-4 border-b pb-4">
		<div class="flex justify-between items-center gap-2 w-full">
			<p class="modal-header font-semibold">Tag dictionary</p>
			<div
				class="group hover:border-green-lighter transition-colors p-2 w-fit rounded-xl flex flex-row cursor-pointer items-center bg-green-lightest tags-intercom-bg hover:bg-green-lighter"
			>
				<div class="flex flex-row flex-1 justify-between gap-3 items-center">
					<p class="text-sm font-bold">Not seeing the tags you need?</p>
					<div
						class="text-green text-xs flex flex-row gap-2 items-center tags-intercom-bot"
					>
						<img
							src="/assets/images/intercom/intercom-circle-logo.svg"
							class="w-8"
						/>
						Chat with us!
					</div>
				</div>
			</div>
		</div>
		<div class="flex items-center justify-between w-full gap-10 mt-4">
			<app-input
				placeholder="Search category or tags"
				(ngModelChange)="onSearchChange($event)"
				[ngModel]="searchValue"
				name="tags-search"
				minSearchTerm="1"
				a
				id="tags-search"
				[endIcon]="ICON.SEARCH"
			></app-input>
			<app-button
				btn="tertiary"
				[icon]="ICON.PRINT"
				class="rounded-md aspect-square border w-10 h-10 flex items-center justify-center"
				(click)="printTagsTable()"
			></app-button>
		</div>
	</div>
	<div class="overflow-y-auto flex-grow">
		<div class="flex w-full h-[555px]">
			<div class="bg-grey-lightest w-[300px]">
				<p class="font-bold mt-3 px-4 pb-2">Tag categories</p>
				<div class="overflow-y-auto max-h-[506px]">
					<div
						*ngFor="let category of filteredCategories$ | async"
						class="w-full"
					>
						<ng-container
							*ngTemplateOutlet="
								categoryTemplate;
								context: { category: category, level: 0 }
							"
						></ng-container>
					</div>
				</div>
			</div>
			<div
				class="flex flex-col items-center flex-1 justify-center w-full h-full"
				*ngIf="!selectedCategory"
			>
				<div class="w-24">
					<img
						src="/assets/images/empty-states/document-clear.svg"
						alt="No category selected"
					/>
				</div>
				<p class="text-center max-w-220 text-grey">
					Browse a category to see tags
				</p>
			</div>
			<div *ngIf="selectedCategory" class="h-[555px] flex-1">
				<div>
					<div class="flex items-center justify-between border-b px-4">
						<p class="font-bold">
							{{ selectedCategory?.ancestors?.join(' / ') }}
							{{ selectedCategory?.ancestors?.length ? ' / ' : '' }}
							{{ selectedCategory?.name }}
						</p>
						<div
							class="flex items-center justify-center h-10 w-10 hover:bg-grey-lighter rounded-md cursor-pointer"
							(click)="showDetails = !showDetails"
						>
							<app-icon
								[icon]="showDetails ? ICON.RIGHT : ICON.LEFT"
								class="text-green"
							/>
						</div>
					</div>
					<div class="max-h-[506px] h-[44rem] pl-4">
						<cdk-virtual-scroll-viewport
							[itemSize]="rowHeightPx"
							class="max-h-[506px] h-[44rem] overflow-y-auto"
						>
							<div *cdkVirtualFor="let item of flatCategories">
								<p
									[ngStyle]="{ height: rowHeightPx + 'px' }"
									[ngClass]="{
										'font-bold mt-1': item.type === 'category',
										'truncate py-2 cursor-pointer pl-4 hover:bg-blue-hover':
											item.type === 'tag',
										'bg-blue-hover border-blue-highlight border':
											selectedTag?.name === item.name,
									}"
									(click)="selectTag(item)"
									[matTooltip]="
										item.name.length > 34 && showDetails ? item.name : null
									"
									matTooltipClass="wide-tooltip"
									[matTooltipShowDelay]="350"
									[innerHTML]="item.name | highlight: searchValue"
								>
									{{ item.name }}
								</p>
							</div>
						</cdk-virtual-scroll-viewport>
					</div>
				</div>
			</div>
			<div class="flex flex-col border-x w-1/3" *ngIf="showDetails">
				<div class="h-36 overflow-auto">
					<div class="flex items-center justify-between mt-3 px-4 pb-2">
						<p class="font-bold">Description</p>
						<div
							class="flex items-center gap-2 font-bold text-white"
							*ngIf="selectedTag"
						>
							<div
								*ngIf="
									selectedTag.fileTypes?.includes(FileType.PURCHASE) ||
									!selectedTag.fileTypes
								"
								class="h-5 w-5 bg-blue text-center rounded flex items-center justify-center"
							>
								P
							</div>
							<div
								*ngIf="
									selectedTag.fileTypes?.includes(FileType.SALE) ||
									!selectedTag.fileTypes
								"
								class="h-5 w-5 bg-orange-400 text-center rounded flex items-center justify-center"
							>
								S
							</div>
							<div
								*ngIf="
									selectedTag.fileTypes?.includes(FileType.REFINANCE) ||
									!selectedTag.fileTypes
								"
								class="h-5 w-5 bg-violet-950 text-center rounded flex items-center justify-center"
							>
								R
							</div>
						</div>
					</div>
					<p class="px-4">{{ selectedTag?.description }}</p>
				</div>
				<div class="border-y p-3">
					<p class="font-bold pb-2">Variations</p>
					<app-dropdown
						(onSelect)="selectHelper($event)"
						[ngModel]="selectedHelper || 'default' | capitalize"
						[itemGroups]="[{ items: helperOptions }]"
					></app-dropdown>
				</div>
				<div class="flex-1 grow px-3">
					<div class="display value-display">
						<p class="font-bold mt-3 pb-2">Actual value</p>
						<div [ngClass]="{ 'text-grey': !tagValueExists }">
							<div [innerHtml]="tagValue"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-4 flex justify-between border-t">
		<app-button btn="border" (click)="cancelModal()">Cancel</app-button>
		<app-button (click)="insertTag()" [disabled]="!selectedTag"
			>Insert tag</app-button
		>
	</div>
</div>

<ng-template #categoryTemplate let-category="category" let-level="level">
	<div
		class="flex items-center justify-between py-3 cursor-pointer"
		[style.paddingLeft.px]="16 + 16 * level"
		(click)="selectCategory(category, level === 0)"
		[ngClass]="{
			'bg-blue-hover border-y border-blue-highlight':
				selectedCategory === category,
			'bg-white': selectedCategory?.ancestors?.includes(category.name),
		}"
	>
		<p>{{ category.name }}</p>
		<p class="bg-grey-lighter px-3 rounded-md font-semibold text-xs">
			{{ category.amount }}
		</p>
	</div>
	<div
		*ngIf="
			category.name !== 'All' &&
			(selectedCategory === category ||
				selectedCategory?.ancestors?.includes(category?.name))
		"
		class="bg-white"
	>
		<div *ngFor="let subCategory of category.subCategory">
			<ng-container
				*ngTemplateOutlet="
					categoryTemplate;
					context: { category: subCategory, level: level + 1 }
				"
			></ng-container>
		</div>
	</div>
</ng-template>
